var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tableData
    ? _c(
        "div",
        { staticClass: "table-responsive" },
        [
          _c(
            "table-editable-list",
            {
              attrs: {
                columns: _vm.columns,
                "show-select": false,
                "show-actions": _vm.showActions,
                "show-columns": _vm.columns
              }
            },
            [
              _c(
                "template",
                { slot: "data-row" },
                [
                  _vm._l(_vm.tableData, function(item, itemIdx) {
                    return [
                      _c(
                        "table-list-row",
                        {
                          key: item.id
                            ? _vm.storeKey + "-" + item.id
                            : _vm.storeKey + "-" + itemIdx,
                          attrs: {
                            columns: _vm.columns,
                            rowdata: item,
                            rowIndex: itemIdx,
                            "show-columns": _vm.columns
                          }
                        },
                        [
                          _vm._l(_vm.columns, function(column) {
                            return [
                              column.customCol
                                ? _c(
                                    "template",
                                    { slot: column.customCol },
                                    [
                                      _vm._t("pt" + column.customCol, null, {
                                        item: item
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ]
                          }),
                          _vm._v(" "),
                          _vm.showActions
                            ? _c("template", { slot: "actions" }, [
                                _c(
                                  "td",
                                  { staticClass: "td-actions" },
                                  [
                                    _c(
                                      "actions-button",
                                      {
                                        attrs: {
                                          "button-index": itemIdx,
                                          menu: _vm.actionsMenu,
                                          "data-struct": item,
                                          rootURL: _vm.entrypoint
                                        }
                                      },
                                      [
                                        _vm._l(_vm.actionsMenu, function(menu) {
                                          return [
                                            menu.aSlot
                                              ? _c(
                                                  "template",
                                                  { slot: menu.aSlot },
                                                  [
                                                    _vm._t(
                                                      "pt" + menu.aSlot,
                                                      null,
                                                      { item: item }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  })
                ],
                2
              )
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }